enum TYPE {
    INCOME = "income",
    EXPENSE = "expense",
    TRANSFER = "transfer",
}

export {
    TYPE,
}